import { Dialog } from "../../compose/Dialog";
import { Button } from "../../compose/controls";

/**
 * ConfirmDialog — a small reusable "are you sure?" modal composed from the shared
 * `Dialog` + `Button` (RULE ZERO: no bespoke modal). Used for destructive actions
 * (document delete/archive) so the confirmation UX is identical everywhere. Fully
 * controlled: the parent renders it only when needed and owns the async action +
 * its `busy` flag.
 */
export function ConfirmDialog({
  title,
  body,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
  testid = "confirm-dialog",
}: {
  title: string;
  body: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  testid?: string;
}) {
  return (
    <Dialog title={title} onClose={onCancel} testid={testid}>
      <p className="dialog__sub" style={{ marginTop: 0 }} data-testid="confirm-body">
        {body}
      </p>
      <div className="dialog__actions">
        <Button
          type="button"
          variant="ghost"
          onClick={onCancel}
          disabled={busy}
          data-testid="confirm-cancel"
        >
          {cancelLabel}
        </Button>
        <button
          type="button"
          className={`btn ${danger ? "btn--danger" : "btn--primary"}`}
          onClick={onConfirm}
          disabled={busy}
          data-testid="confirm-accept"
        >
          {busy ? "Working…" : confirmLabel}
        </button>
      </div>
    </Dialog>
  );
}
